import { Fragment, useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import config from '../../../config';

const MySubjects = () => {

  const user = useSelector((state) => state.auth?.user);

  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    // wait until Redux user loads
    if (!user || !user.email) {
      setLoading(false);
      return;
    }

    loadSubjects();

  }, [user]);

  const loadSubjects = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${config.apiBaseUrl}/staffs/get-teacher-subjects.php?email=${user.email}`
      );

      console.log("API:", res.data);

      setSubjects(res.data?.data || []);

    } catch (err) {
      console.error("Load subjects error:", err);
      setSubjects([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <div className="row">

        {loading && (
          <div className="col-12 text-muted">
            Loading subjects...
          </div>
        )}

        {!loading && subjects.length === 0 && (
          <div className="col-12 text-muted">
            No subjects assigned
          </div>
        )}

        {!loading && subjects.map(sub => (
          <div className="col-md-4 mb-3" key={sub.subject_code}>
            <div className="card shadow-sm">
              <div className="card-body">

                <h5 className="fw-bold">
                  {sub.subject_code}
                </h5>

                <p className="mb-1">
                  {sub.subject_name}
                </p>

                <small className="text-muted">
                  {sub.class_name} {sub.section}
                </small>

                <div className="mt-3 d-flex gap-2">

                  <button className="btn btn-sm btn-outline-primary">
                    View Students
                  </button>

                  <button className="btn btn-sm btn-primary">
                    Enter Marks
                  </button>

                </div>

              </div>
            </div>
          </div>
        ))}

      </div>
    </Fragment>
  );
};

export default MySubjects;
